import React, { useState } from 'react'
import {Shield, Check, ChevronDown, ChevronUp} from 'lucide-react'

function App() {
  const [expandedSection, setExpandedSection] = useState<string | null>(null)

  const toggleSection = (section: string) => {
    setExpandedSection(expandedSection === section ? null : section)
  }

  const handleCheckout = () => {
    window.open('https://pay.kirvano.com/31220965-2fd7-458b-9b79-c84a1874cd50', '_blank')
  }

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* HERO - OFERTA DE IMPULSO */}
      <section className="px-6 py-12 md:py-16 max-w-2xl mx-auto text-center">
        <div className="mb-6 flex justify-center">
          <Shield className="w-12 h-12 text-[#1e3a8a]" strokeWidth={1.5} />
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
          Descubra agora se você pode receber pensão na gravidez — Guia completo imediato
        </h1>
        
        <p className="text-lg text-gray-700 mb-8 leading-relaxed">
          <strong>Entenda seus direitos em minutos:</strong> explicação clara sobre alimentos gravídicos, checklist prático e o que você precisa saber antes de qualquer decisão.
        </p>

        {/* PREÇO DESTAQUE */}
        <div className="bg-gray-50 border-2 border-[#1e3a8a] rounded-lg p-6 mb-6 inline-block">
          <p className="text-gray-700 mb-2">Acesso completo por apenas</p>
          <p className="text-5xl font-bold text-[#1e3a8a] mb-3">R$ 17,90</p>
          <p className="text-sm text-gray-600">Pagamento único • Acesso imediato</p>
        </div>

        {/* CTA PRINCIPAL */}
        <button 
          onClick={handleCheckout}
          className="bg-[#1e3a8a] text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-[#1e40af] transition-colors w-full md:w-auto shadow-lg mb-4"
        >
          Acessar guia completo — R$ 17,90
        </button>
        
        <p className="text-sm text-gray-600 mb-8">
          <Check className="w-4 h-4 inline text-green-600" /> Acesso imediato após pagamento • <Shield className="w-4 h-4 inline text-[#1e3a8a]" /> Garantia de 7 dias
        </p>

        {/* O QUE VOCÊ RECEBE */}
        <div className="text-left bg-blue-50 border border-[#1e3a8a] rounded-lg p-6 mt-8">
          <h3 className="font-bold text-gray-900 mb-4 text-center">✓ O que você recebe agora:</h3>
          <ul className="space-y-2 text-gray-800">
            <li className="flex items-start gap-2">
              <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
              <span>Guia completo sobre pensão na gravidez (alimentos gravídicos)</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
              <span>Checklist prático: documentos e informações importantes</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
              <span>Explicação clara, sem juridiquês</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
              <span>Erros comuns a evitar</span>
            </li>
          </ul>
        </div>
      </section>

      {/* DEPOIMENTOS CURTOS */}
      <section className="bg-gray-50 px-6 py-12">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">O que outras leitoras disseram:</h2>
          <div className="space-y-4">
            <div className="bg-white p-5 rounded-lg border border-gray-200">
              <p className="text-[#1e3a8a] mb-2">★★★★★</p>
              <p className="text-gray-800">"Me ajudou a entender meus direitos e me senti mais segura."</p>
              <p className="text-gray-600 text-sm mt-2">— R., 29 anos</p>
            </div>
            <div className="bg-white p-5 rounded-lg border border-gray-200">
              <p className="text-[#1e3a8a] mb-2">★★★★★</p>
              <p className="text-gray-800">"Explicação clara e direta. Valeu cada centavo."</p>
              <p className="text-gray-600 text-sm mt-2">— C., 25 anos</p>
            </div>
            <div className="bg-white p-5 rounded-lg border border-gray-200">
              <p className="text-[#1e3a8a] mb-2">★★★★★</p>
              <p className="text-gray-800">"Não sabia que tinha direito a isso. O checklist foi muito útil."</p>
              <p className="text-gray-600 text-sm mt-2">— M., 32 anos</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA REPETIDO */}
      <section className="px-6 py-12 max-w-2xl mx-auto text-center bg-white">
        <button 
          onClick={handleCheckout}
          className="bg-[#1e3a8a] text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-[#1e40af] transition-colors w-full md:w-auto shadow-lg mb-3"
        >
          Acessar guia completo — R$ 17,90
        </button>
        <p className="text-sm text-gray-600">
          <Check className="w-4 h-4 inline text-green-600" /> Acesso imediato • <Shield className="w-4 h-4 inline text-[#1e3a8a]" /> Garantia de 7 dias
        </p>
      </section>

      {/* SEÇÕES EDUCATIVAS COLAPSÁVEIS (OPCIONAL) */}
      <section className="px-6 py-8 max-w-2xl mx-auto border-t border-gray-200">
        <p className="text-center text-gray-600 text-sm mb-6">Quer saber mais detalhes antes de acessar? Confira abaixo:</p>

        {/* O que é pensão na gravidez */}
        <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
          <button
            onClick={() => toggleSection('explicacao')}
            className="w-full px-6 py-4 bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between text-left"
          >
            <span className="font-semibold text-gray-900">O que é pensão na gravidez?</span>
            {expandedSection === 'explicacao' ? (
              <ChevronUp className="w-5 h-5 text-gray-600" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-600" />
            )}
          </button>
          {expandedSection === 'explicacao' && (
            <div className="px-6 py-4 bg-white text-gray-800 leading-relaxed">
              <p className="mb-3">
                A legislação brasileira prevê a possibilidade de que, em determinadas situações, o genitor possa ser chamado a contribuir financeiramente ainda durante a gestação — isso é conhecido como "alimentos gravídicos".
              </p>
              <p>
                Esse tema pode ser analisado conforme cada caso específico. Não é automático, não é garantido, e cada situação é avaliada individualmente pela Justiça.
              </p>
            </div>
          )}
        </div>

        {/* O que você vai entender */}
        <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
          <button
            onClick={() => toggleSection('conteudo')}
            className="w-full px-6 py-4 bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between text-left"
          >
            <span className="font-semibold text-gray-900">O que você vai entender ao ler este guia</span>
            {expandedSection === 'conteudo' ? (
              <ChevronUp className="w-5 h-5 text-gray-600" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-600" />
            )}
          </button>
          {expandedSection === 'conteudo' && (
            <div className="px-6 py-4 bg-white">
              <ul className="space-y-3 text-gray-800">
                <li className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
                  <span>Como funciona a pensão na gravidez na prática</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
                  <span>Em quais situações o tema costuma ser analisado</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
                  <span>Quais despesas costumam ser consideradas</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
                  <span>O que organizar antes de qualquer decisão</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" />
                  <span>Erros comuns que geram frustração</span>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* O que este guia NÃO faz */}
        <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
          <button
            onClick={() => toggleSection('nao-faz')}
            className="w-full px-6 py-4 bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-between text-left"
          >
            <span className="font-semibold text-gray-900">O que este guia NÃO faz</span>
            {expandedSection === 'nao-faz' ? (
              <ChevronUp className="w-5 h-5 text-gray-600" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-600" />
            )}
          </button>
          {expandedSection === 'nao-faz' && (
            <div className="px-6 py-4 bg-white">
              <ul className="space-y-2 text-gray-800">
                <li className="flex items-start gap-2">
                  <span className="text-[#1e3a8a] mt-0.5">✗</span>
                  <span>Não garante a concessão de pensão na gravidez</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#1e3a8a] mt-0.5">✗</span>
                  <span>Não promete valores ou resultados específicos</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#1e3a8a] mt-0.5">✗</span>
                  <span>Não substitui orientação jurídica individual</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#1e3a8a] mt-0.5">✗</span>
                  <span>Não indica se você deve ou não entrar com ação</span>
                </li>
              </ul>
              <p className="text-gray-700 mt-4 text-sm">
                Este é um material educativo de leitura, voltado para quem busca compreender o tema antes de qualquer decisão.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="px-6 py-12 max-w-2xl mx-auto text-center bg-gray-50">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">Pronta para entender seus direitos?</h3>
        <button 
          onClick={handleCheckout}
          className="bg-[#1e3a8a] text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-[#1e40af] transition-colors w-full md:w-auto shadow-lg mb-3"
        >
          Acessar guia completo — R$ 17,90
        </button>
        <p className="text-sm text-gray-600 mb-6">
          <Check className="w-4 h-4 inline text-green-600" /> Acesso imediato após pagamento • <Shield className="w-4 h-4 inline text-[#1e3a8a]" /> Garantia de 7 dias
        </p>
        <p className="text-xs text-gray-500">
          Se não for útil, você tem 7 dias para solicitar reembolso. Sem complicação.
        </p>
      </section>

      {/* AVISO LEGAL */}
      <footer className="bg-gray-100 px-6 py-8 text-center border-t border-gray-200">
        <p className="text-gray-600 text-xs max-w-2xl mx-auto leading-relaxed">
          <strong>Aviso legal:</strong> Material educativo de caráter informativo. Não substitui consulta jurídica individual. Não garante resultados, valores ou decisões judiciais. Cada caso deve ser analisado individualmente por profissional habilitado.
        </p>
      </footer>
    </div>
  )
}

export default App
